import { render, staticRenderFns } from "./CustomerPass.vue?vue&type=template&id=7d64e8da&scoped=true&"
import script from "./CustomerPass.vue?vue&type=script&lang=js&"
export * from "./CustomerPass.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPass.vue?vue&type=style&index=0&id=7d64e8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d64e8da",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/CustomerPass.vue
// module id = null
// module chunks = 